import React from "react";
import { useLettersQuery } from "./useLettersQuery";
import LettersFilterBar from "./LettersFilterBar";
import LettersTable from "./LettersTable";
import Dashboardnavbar from "../../../layout/Dashboardnavbar"; // ⚠️ verify this path matches how ProjectDetails.jsx/DPRAuditLog import it
import "./Lettersregister.css";

/**
 * projectDetailsScopeId: pass the ProjectDetails id when mounting as a tab inside a single
 * project (next to "Workstages of X" / "EOT Timeline"). Locks the query to that project
 * and hides the project dropdown/badge in the filter bar and table.
 */
export default function LettersRegister({ projectDetailsScopeId }) {
  const { filters, setFilter, setFilters, setSort, clearFilters, data, loading, error } = useLettersQuery();

  React.useEffect(() => {
    if (projectDetailsScopeId && filters.project_details !== String(projectDetailsScopeId)) {
      setFilter("project_details", String(projectDetailsScopeId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectDetailsScopeId]);

  const totalPages = Math.max(1, Math.ceil(data.count / (data.page_size || 25)));
  const currentPage = Number(filters.page) || 1;

  return (
    <>
      {!projectDetailsScopeId && <Dashboardnavbar name="Letters Register" url="" />}

      <div style={{ padding: "24px 30px" }} className="letters-register-page">
        <LettersFilterBar
          filters={filters}
          setFilter={setFilter}
          setFilters={setFilters}
          clearFilters={clearFilters}
          projectDetailsScopeId={projectDetailsScopeId}
        />

        {error ? (
          <div className="letters-table-state letters-error">Couldn't load letters. Please try again.</div>
        ) : (
          <>
            <div className="letters-result-count">
              {loading ? "Loading…" : `${data.count} letter${data.count === 1 ? "" : "s"} found`}
            </div>

            <LettersTable rows={data.results} loading={loading} ordering={filters.ordering} onSort={setSort} />

            {totalPages > 1 && (
              <div className="letters-pagination">
                <button disabled={currentPage <= 1} onClick={() => setFilter("page", String(currentPage - 1))}>
                  Previous
                </button>
                <span>
                  Page {currentPage} of {totalPages}
                </span>
                <button disabled={currentPage >= totalPages} onClick={() => setFilter("page", String(currentPage + 1))}>
                  Next
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}